<div class="h-100 d-flex overflow-y-auto overflow-x-hidden">
    <prozess-navigation *ngIf="this.portalkonfiguration.mittelabrufAbschnitt && navItem" class="sidebar" [ngClass]="{ 'collapsed': false, 'collapsed-mobile': true }">
        <div>
            <app-navigation-item
                [name]="navItem.name"
                [href]="'./' + navItem.link"
                [isValid]="true"
                [isActive]="true"
                [showValidationStatus]="false"
                >
            </app-navigation-item>
        </div>
    </prozess-navigation>
    <div class="mt-8 px-3 max-w-2xl mx-auto w-100 content">
        <section-info [overrideTitle]="'payments' | translate" [attr.aria-label]="'payments' | translate" [overrideDescription]="abschnittInfotext"></section-info>
    
        <div *ngIf="! payments.length">
            {{ 'payments.no_payments_available' | translate }}!
        </div>

        <app-pending-amounts
            [showFoerdersummeOffen]="true"
            ></app-pending-amounts>

        <app-funding-table
            [type]="type"
            [anfrage]="anfrage"
            [portalkonfiguration]="portalkonfiguration"
            [(foerdersummeOffen)]="fundingAmounts.foerdersummeOffen"
            ></app-funding-table>
    </div>
    
    <anfrage-infoarea class="info" [ngClass]="{ 'hidden': ! true }"></anfrage-infoarea>
</div>
